import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { EditorConfig } from '@root/app.constant';
import { CatalogService } from '@catalog/catalog.service';
import { ToastrService } from 'ngx-toastr';
import { JobData } from '../catalouge-careers.model';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-create-job',
  templateUrl: './create-job.component.html',
  styleUrls: ['./create-job.component.scss'],
  providers: [CatalogService],
})
export class CreateJobComponent implements OnInit {
  @ViewChild('f', { static: false }) form: NgForm;

  @Input() jobData: JobData;

  @Output() refreshChange = new EventEmitter();

  skillSelection = new SelectionModel<string>(true, []);

  activeskill: string;

  editorConfig = EditorConfig;

  departmentList: [];

  locationList: [];

  // jobData = new JobData();

  constructor(
    private catalogService: CatalogService,
    private toastr: ToastrService
  ) {
    this.editorConfig.placeholder = 'Write job discription...';
  }

  public onAddSkill() {
    this.skillSelection.select(this.activeskill);
    this.activeskill = '';
  }

  ngOnInit() {
    this.readDepartment();
    this.readLocation();
  }

  public readLocation() {
    this.catalogService.getCareersLocation().subscribe(
      (response) => {
        this.locationList = response.data.locations;
      },
      (error) => {
        this.toastr.error(error.errorMessage);
      }
    );
  }
  public readDepartment() {
    this.catalogService.getCareersDeparment().subscribe(
      (response) => {
        this.departmentList = response.data.departments;
      },
      (error) => {
        this.toastr.error(error.errorMessage);
      }
    );
  }

  public processData() {
    this.jobData.skills = this.skillSelection.selected.toString();
    this.catalogService.addOrUpdateCareer(this.jobData).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.resetForm();
          this.refreshChange.emit();
        } else {
          this.toastr.error(response.error.errorMessage);
        }
      },
      (error) => {
        this.toastr.error(error.error.errorMessage);
      }
    );
  }

  public resetForm() {
    if (this.form) {
      this.form.resetForm();
    }
  }
}
